import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
// import { IcoMoon } from "../../common";
import styles from "./styles.less";

const BookingRating = ({ className, titles, rate, isRtl, isMobileView }) => {
  // const renderStaredRates = rate => {
  //   let numberOfFulledStars = 0;
  //   let numberOfEmptyStars = 5;
  //   let hasHalfStar = false;
  //   numberOfFulledStars = Math.floor(rate);
  //   hasHalfStar = rate % numberOfFulledStars > 0;
  //   numberOfEmptyStars = 5 - numberOfFulledStars;
  //   if (hasHalfStar) {
  //     numberOfEmptyStars - 1;
  //   }

  //   const fullStarsHolder = [];
  //   for (let i = 0; i < numberOfFulledStars; i++) {
  //     fullStarsHolder.push(
  //       <IcoMoon key={"bookingfullstar" + i} name="star" color="#FBC105" />
  //     );
  //   }

  //   const emptyStarsHolder = [];
  //   for (let i = 0; i < numberOfEmptyStars; i++) {
  //     emptyStarsHolder.push(
  //       <IcoMoon
  //         key={"bookingemptystar" + i}
  //         name="star-outline"
  //         color="#758892"
  //       />
  //     );
  //   }

  //   return (
  //     <React.Fragment>
  //       {fullStarsHolder}
  //       {hasHalfStar && <IcoMoon name="star-half" color="#FBC105" />}
  //       {emptyStarsHolder}
  //     </React.Fragment>
  //   );
  // };

  return (
    <div
      className={cx(
        styles.bookingRating,
        className,
        { [styles.rtl]: isRtl },
        { [styles.mobileView]: isMobileView }
      )}
    >
      <div className={styles.rate}>
        <span className={styles.numberedRate}>{rate}</span>
        {/* <div className={styles.staredRate}>{renderStaredRates(rate / 2)}</div> */}
        <div className={styles.subtitle}>
          {titles.CartBookingRatingSubtitle}
        </div>
      </div>
    </div>
  );
};

BookingRating.defaultProps = {
  titles: {},
  isRtl: false
};

BookingRating.propTypes = {
  titles: PropTypes.object,
  rate: PropTypes.number,
  className: PropTypes.string,
  isRtl: PropTypes.bool,
  isMobileView: PropTypes.bool
};

export default BookingRating;



// WEBPACK FOOTER //
// ./src/components/Cart/BookingRating/BookingRating.js